<template>
	<section class="container stats" aria-label="At a glance">
		<div v-for="stat in stats" :key="stat.value" :class="['card', 'stat', { highlight: stat.highlight }]">
			<span class="cap stat-value">{{ stat.value }}</span>
			<span class="stat-text">{{ stat.text }}</span>
		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {
			stats: [
				{ value: "1993", text: "Pablo's first year on the mats" },
				{ value: "4th degree", text: "Black belt head coach" },
				{ value: "150 m²", text: "Of professional tatami" },
				{ value: "6 days", text: "Classes Monday to Saturday", highlight: true },
			],
		};
	},
};
</script>

<style scoped>
.stats {
	position: relative;
	margin-top: -48px;
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 12px;
}

.stat {
	padding: 22px 24px;
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.stat.highlight {
	background: var(--mat);
	border-color: var(--mat);
}

.stat-value {
	font-size: 40px;
	line-height: 1;
}

.stat-text {
	font-size: 14px;
	color: var(--muted);
}

.highlight .stat-text {
	color: var(--ink);
}

@media (max-width: 960px) {
	.stats {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 768px) {
	.stats {
		margin-top: 20px;
		gap: 10px;
	}

	.stat {
		padding: 16px;
	}

	.stat-value {
		font-size: 30px;
	}

	.stat-text {
		font-size: 13px;
	}
}
</style>
